export const c_slider__thumb_BoxShadow = {
  "name": "--pf-c-slider__thumb--BoxShadow",
  "value": "0 0 0 2px #fff,\n    0 0 0 3px #06c,\n    0 0 2px 5px #bee1f4",
  "var": "var(--pf-c-slider__thumb--BoxShadow)"
};
export default c_slider__thumb_BoxShadow;